import React from 'react';

function PrivacyPolicyMc(props) {


    return (
        <div>
            <header>
                <h1>Privacy Policy for Skins Pack: Mc Skin Editor</h1>
            </header>
            <section>
                <h2>Introduction</h2>
                <p>
                    We are committed to respecting the privacy of our users. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use Skins Pack: Mc Skin Editor.
                </p>

                <h2>Collection of Information</h2>
                <p>
                    We may collect information about you in a variety of ways. The information we may collect via the Application includes:
                </p>
                <ul>
                    <li>Personal Data: Personally identifiable information, such as your name, email address, and demographic information.</li>
                    <li>Derivative Data: Information our servers automatically collect when you access the App, such as your IP address, device type, operating system, and access times.</li>
                    <li>Data from Social Networks: User information from social networking sites.</li>
                </ul>

                <h2>Use of Information</h2>
                <p>
                    We use collected information to deliver targeted advertising, provide, operate, and maintain our services, improve our services, and communicate with you.
                </p>

                <h2>Disclosure of Information</h2>
                <p>
                    We may share information we have collected about you in certain situations. Your information may be disclosed to:
                </p>
                <ul>
                    <li>Advertisers for marketing purposes.</li>
                    <li>Third-party service providers that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, and marketing assistance.</li>
                </ul>

                <h2>Third-Party Services</h2>
                <p>
                    The app uses third-party services that may collect information used to identify you. Links to privacy policies of third-party service providers used by the app:
                </p>
                <ul>
                    <li>Google Play Services</li>
                    <li>AdMob</li>
                    <li>Facebook</li>
                    <li>Unity Ads</li>
                    <li>OneSignal</li>
                    <li>Yodo1 Ads</li>
                </ul>

                <h2>Security of Information</h2>
                <p>
                    We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that no security measures are perfect or impenetrable.
                </p>

                <h2>Contact Us</h2>
                <p>
                    If you have any questions or comments about this Privacy Policy, please contact us at: [Your Contact Information].
                </p>
            </section>
        </div>
    );
}

export default PrivacyPolicyMc;